import React from "react";

const TextAreaSection = ({
  title,
  name,
  value,
  placeholder,
  handleInputChange,
  showTitle = true,
}) => (
  <div>
    {showTitle && (
      <>
        <h3 className="font-bold text-lg p-2 font-poppin">{title}</h3>
        <hr />
      </>
    )}
    <div className="p-3">
      <textarea
        name={name}
        type="text"
        placeholder={placeholder}
        defaultValue={value}
        className="add_user_input w-full h-full min-h-[200px] p-2"
        onChange={handleInputChange}
        rows="4"
      />
    </div>
  </div>
);

export default TextAreaSection;
